export default "__VITE_ASSET__C9Pj8EIe__"